import {
  Blank as BlankUI,
  ColorPicker as ColorPickerUI,
  Divider,
  ElementsArea as ElementsAreaUI,
  IconButtonButton,
  IconButtonInnerChild,
  InputsGroup,
  InputsGroupELement,
  InputsGroupElements,
  LinearProgress as LinearProgressUI,
  Message,
  NumberInput as NumberInputUI,
  Popup,
} from "@evergis/ui";
import { LargeIconButtonContainer, textContainerMixin } from "components/Buttons/styled";
import styled from "styled-components";
import { SymbolPreview as SymbolPreviewUI } from "../SymbolEditor/components/SymbolPreview";
import { SymbolLibrary as SymbolLibraryUI } from "../SymbolActions/components/SymbolLibrary/SymbolLibrary";
import {
  NonEditableField,
  nonEditableFieldMixin,
} from "./components/InputsAndValues/components/NonEditableField/styled";
import { ScrollableContainer } from "../../modules/Style/styled";

export const PopupWithCustomBlank = styled(Popup)`
  position: absolute;
  overflow-x: hidden;
`;

export const Dash = styled.span`
  ${nonEditableFieldMixin};
  margin-right: auto;
  padding: 0 0.4rem 0 0.2rem;
`;

export const InputsContainer = styled(InputsGroup)<{ isFirst?: boolean; isColumn?: boolean }>`
  display: flex;
  align-items: center;
  flex-grow: 1;
  flex-shrink: 0;

  ${InputsGroupElements} {
    width: 100%;
    align-items: ${({ isColumn }) => (isColumn ? "flex-start" : "center")};
  }

  ${InputsGroupELement} {
    &:first-child {
      flex: 1;
      ${({ isColumn }) => (isColumn ? "margin-bottom: 0.5rem;" : "margin-top: auto; margin-bottom: auto;")};

      ${NonEditableField} {
        display: inline-block;
        max-width: ${({ isColumn }) => (isColumn ? "100%" : "2.85rem")};
        line-height: 1rem;
        vertical-align: middle;
      }
    }

    &:nth-child(2) {
      input {
        border-top-left-radius: ${({ isFirst }) => !isFirst && "0.125rem"};
        border-bottom-left-radius: ${({ isFirst }) => !isFirst && "0.125rem"};
      }
    }
  }
`;

export const VerticalContainer = styled.div`
  display: flex;
  flex-direction: column;

  :focus {
    outline: none;
  }
`;

export const PixelInputContainer = styled.div`
  margin: 0.375rem;
  padding: 0.625rem 0.375rem;
  background: rgba(0, 0, 0, 0.06);
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.smallest};
  height: calc(100% - 0.375rem - 0.375rem);
  box-sizing: border-box;
  /** TODO: */
  display: flex;
  align-items: center;
`;

export const PixelInput = styled(NumberInputUI)`
  margin: 0;
  padding-right: 1.5rem;
  background: ${({ theme: { palette } }) => palette.background};
`;

export const InputsAndLabelContainer = styled.div`
  margin: auto;
  display: flex;
  width: 12rem;
  align-items: start;
  align-self: start;
  flex-direction: column;
  flex-grow: 1;
  justify-content: space-between;
  padding: 0.75rem 0.25rem 0.5rem 0.4375rem;
  height: 100%;
  box-sizing: border-box;
`;

export const ClassificationBlank = styled(BlankUI)`
  line-height: unset;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  margin-top: 0.5rem;
  flex-shrink: 0;
`;

export const InputDescription = styled.div`
  color: ${({ theme: { palette } }) => palette.textDisabled};
  margin-top: 0.25rem;
  font-size: 0.625rem;
  line-height: 0.75rem;
  letter-spacing: 0.0833333px;
`;

export const ClassificationBlockContainer = styled(VerticalContainer)`
  flex-grow: 1;
`;

export const SymbolPreviewContainer = styled(VerticalContainer)`
  align-items: center;
`;

export const Header = styled(ElementsAreaUI)`
  display: flex;
  flex-shrink: 0;
  padding: 1rem 1.5rem 0.75rem;
`;

export const VerticalFlex = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.div`
  display: flex;
  flex-grow: 1;
  font: ${({ theme: { fonts } }) => fonts.subtitle};
  color: ${({ theme: { palette } }) => palette.textPrimary};
  margin-bottom: 0.25rem;
`;

export const ButtonsContainer = styled(VerticalFlex)`
  flex-direction: row;
  margin-bottom: 0.625rem;
  flex-shrink: 0;

  > ${IconButtonButton} {
    max-width: 7.5rem;
    font: ${({ theme: { fonts } }) => fonts.small};

    span[kind] {
      margin-right: 0.5rem;
    }
  }

  > ${LargeIconButtonContainer} {
    padding-left: 0.5rem;

    &:not(:first-of-type) {
      margin-left: 2.5rem;
    }
  }
`;

export const ElementsArea = styled(ElementsAreaUI)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 0;
  max-height: calc(100% - 6rem);

  ${ScrollableContainer}, ${ButtonsContainer} {
    padding: 0.5rem 1.5rem 0;
  }

  ${ScrollableContainer} {
    padding-top: 0;
    padding-bottom: 1.25rem;
  }
`;

export const ColorPicker = styled(ColorPickerUI)`
  margin: 1rem;
`;

export const LinearProgress = styled(LinearProgressUI)`
  margin-top: 0.875rem;
`;

export const ClassesDivider = styled(Divider)`
  margin: 1.25rem 0 0.75rem;
`;

export const ClassBlankChildContent = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  margin: auto;
`;

export const SymbolPreview = styled(SymbolPreviewUI)`
  margin: 4px;
`;

export const SymbolLibrary = styled(SymbolLibraryUI)`
  height: 1.5rem;
  margin-right: auto;
  padding-left: 0.5rem;

  ${IconButtonInnerChild} {
    ${textContainerMixin};
  }
`;

export const WarningMessage = styled(Message)`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 0.5rem;
`;
WarningMessage.defaultProps = { warning: true };

export const MessageContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 1rem;
  font-size: 0.625rem;
`;

export const MessageTitle = styled.div`
  font-size: 1rem;
`;
